"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/tags/index.ts
var tags_exports = {};
__export(tags_exports, {
  default: () => Tags_default
});
module.exports = __toCommonJS(tags_exports);

// src/tags/Tags.tsx
var import_classnames3 = __toESM(require("classnames"));

// src/tags/_Tag.tsx
var import_react3 = require("react");

// src/fontAwesomeV6Icon/FontAwesomeV6Icon.tsx
var import_classnames = __toESM(require("classnames"));
var import_jsx_runtime = require("react/jsx-runtime");
var FontAwesomeV6Icon = ({
  iconStyle,
  iconFamily,
  iconName,
  className,
  title,
  animationType,
  ...HTMLAttributes2
}) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
  "i",
  {
    "data-testid": "font-awesome-v6-icon",
    className: (0, import_classnames.default)(
      iconFamily && `fa-${iconFamily}`,
      iconStyle && `fa-${iconStyle}`,
      iconName && `fa-${iconName}`,
      // Default icon style is solid, but only when no iconFamily prop is provided
      !iconFamily && !iconStyle && "fa-solid",
      animationType && `fa-${animationType}`,
      className
    ),
    title,
    ...HTMLAttributes2
  }
);
var FontAwesomeV6Icon_default = FontAwesomeV6Icon;

// src/tooltip/_Tooltip.tsx
var import_classnames2 = __toESM(require("classnames"));
var import_react = require("react");

// src/tooltip/tooltip.module.scss
var css = `@charset "UTF-8";
/* This is a collection of Primitive Colors.
 Unlike Semantic colors (color.css) these variables will be equal to the same color value in all themes.
 Ideally, these colors should be used for components that are not theme dependent.
 In the future it's possible that we will only need to use these colors in Semantic colors (colors.css).
 */
/* Colors are taken from DISCO Variables New Figma File - Primitive colors variables collection
 via variables2css plugin that generates css code based on Figma variables values and names.
 We're using css here in order to support not only scss, but also css files.
 :root is used here instead of "[data-theme="Mode 1"]" to define css variables
 that can be used in the entire app. 
 Also, stylelint fix might be required for autogenerated colors, which can be done in one command.
 */
/* Primitive Colors */
:root {
  --accent-orange-10: #fff6e5;
  --accent-orange-100: #5c3b00;
  --accent-orange-20: #ffe5b7;
  --accent-orange-30: #ffd58a;
  --accent-orange-40: #ffc55c;
  --accent-orange-50: #ffb42e;
  --accent-orange-60: #ffa400;
  --accent-orange-70: #d68a00;
  --accent-orange-80: #ad7000;
  --accent-orange-90: #855500;
  --accent-strawberry-10: #ffe3e3;
  --accent-strawberry-100: #430d0d;
  --accent-strawberry-20: #ffcdcd;
  --accent-strawberry-30: #ffabab;
  --accent-strawberry-40: #f88585;
  --accent-strawberry-50: #ed6060;
  --accent-strawberry-60: #cb4a4a;
  --accent-strawberry-70: #a93737;
  --accent-strawberry-80: #872626;
  --accent-strawberry-90: #651818;
  --brand-aqua-10: #ebfffe;
  --brand-aqua-100: #005552;
  --brand-aqua-20: #bffffc;
  --brand-aqua-30: #94fffb;
  --brand-aqua-40: #68fff9;
  --brand-aqua-50: #3cfff7;
  --brand-aqua-60: #29ddd6;
  --brand-aqua-70: #19bbb5;
  --brand-aqua-80: #0d9994;
  --brand-aqua-90: #047773;
  --brand-purple-10: #e2d4ee;
  --brand-purple-100: #2f1c3e;
  --brand-purple-20: #decaee;
  --brand-purple-30: #d0b6e5;
  --brand-purple-40: #b592d2;
  --brand-purple-5: #f6edfd;
  --brand-purple-50: #8c52ba;
  --brand-purple-60: #7f4aa9;
  --brand-purple-70: #6c468a;
  --brand-purple-80: #5c3778;
  --brand-purple-90: #46295c;
  --brand-teal-10: #bfe4e8;
  --brand-teal-100: #00383f;
  --brand-teal-20: #aed8dc;
  --brand-teal-30: #85cad1;
  --brand-teal-40: #50b2bd;
  --brand-teal-5: #e0f8f9;
  --brand-teal-50: #0093a4;
  --brand-teal-60: #008493;
  --brand-teal-70: #007785;
  --brand-teal-80: #00636e;
  --brand-teal-90: #004b54;
  --neutral-base-black: #292f36;
  --neutral-base-white: #ffffff;
  --neutral-black-alpha-10: #292f361a;
  --neutral-black-alpha-20: #292f3633;
  --neutral-black-alpha-30: #292f364d;
  --neutral-black-alpha-40: #292f3666;
  --neutral-black-alpha-5: #292f360d;
  --neutral-black-alpha-50: #292f3680;
  --neutral-black-alpha-60: #292f3699;
  --neutral-black-alpha-70: #292f36b2;
  --neutral-black-alpha-80: #292f36cc;
  --neutral-black-alpha-90: #292f36e5;
  --neutral-black-alpha-95: #292f36f2;
  --neutral-gray-10: #e4e6e9;
  --neutral-gray-20: #d1d4d8;
  --neutral-gray-30: #bec2c7;
  --neutral-gray-40: #abb0b6;
  --neutral-gray-5: #f7f8fa;
  --neutral-gray-50: #989ea5;
  --neutral-gray-60: #858c94;
  --neutral-gray-70: #727a83;
  --neutral-gray-80: #5f6872;
  --neutral-gray-90: #4c5661;
  --neutral-gray-95: #394450;
  --neutral-white-alpha-10: #ffffff1a;
  --neutral-white-alpha-20: #ffffff33;
  --neutral-white-alpha-30: #ffffff4d;
  --neutral-white-alpha-40: #ffffff66;
  --neutral-white-alpha-5: #ffffff0d;
  --neutral-white-alpha-50: #ffffff80;
  --neutral-white-alpha-60: #ffffff99;
  --neutral-white-alpha-70: #ffffffb2;
  --neutral-white-alpha-80: #ffffffcc;
  --neutral-white-alpha-90: #ffffffe5;
  --neutral-white-alpha-95: #fffffff2;
  --sentiment-error-10: #ffe1dd;
  --sentiment-error-100: #480e07;
  --sentiment-error-20: #ffbfb6;
  --sentiment-error-30: #ff8677;
  --sentiment-error-40: #f95d4a;
  --sentiment-error-50: #e02d16;
  --sentiment-error-60: #c12814;
  --sentiment-error-70: #aa2513;
  --sentiment-error-80: #842418;
  --sentiment-error-90: #6a1b11;
  --sentiment-information-10: #dceffb;
  --sentiment-information-100: #0b2946;
  --sentiment-information-20: #bde0fa;
  --sentiment-information-30: #83c7f6;
  --sentiment-information-40: #40aaf0;
  --sentiment-information-50: #1892e3;
  --sentiment-information-60: #0b71be;
  --sentiment-information-70: #0a5a9a;
  --sentiment-information-80: #0d4d7f;
  --sentiment-information-90: #10416a;
  --sentiment-success-10: #e2f6e2;
  --sentiment-success-100: #0e360f;
  --sentiment-success-20: #c7ecc6;
  --sentiment-success-30: #9adc99;
  --sentiment-success-40: #66c365;
  --sentiment-success-50: #3ea33e;
  --sentiment-success-60: #308930;
  --sentiment-success-70: #286d29;
  --sentiment-success-80: #245724;
  --sentiment-success-90: #1f4820;
  --sentiment-warning-10: #fefce8;
  --sentiment-warning-100: #5e330f;
  --sentiment-warning-20: #fef8c3;
  --sentiment-warning-30: #fded8b;
  --sentiment-warning-40: #fcdc48;
  --sentiment-warning-50: #f9cb28;
  --sentiment-warning-60: #e9ae09;
  --sentiment-warning-70: #c88504;
  --sentiment-warning-80: #a05f08;
  --sentiment-warning-90: #7d4b07;
}

/* This file consists of Semantic colors,
 if you need DSCO colors with support of multiple themes, you need to import and use this file.
 */
/* Colors are taken from DSCO Variables New Figma File - Semantic colors colors variables collection
 via variables2css plugin that generates css code based on Figma variables values and names.
 We're using css here in order to support not only scss, but also css files.
 Also, stylelint fix might be required for autogenerated colors, which can be done in one command.
 */
/* Semantic Colors */
/* Semantic colors values are taken from Primitive Colors (primitiveColors.css).
 Semantic color value is specified for every theme, meaning that unlike Primitive Colors (primitiveColors.css), Semantic colors are meant to be different for every theme.
 */
/* Light theme Semantic colors 
(Light theme is a default one, that's why here's also :root rule)
*/
:root,
[data-theme=Light] {
  --background-brand-aqua-light: var(--brand-aqua-10);
  --background-brand-aqua-primary: var(--brand-aqua-50);
  --background-brand-aqua-strong: var(--brand-aqua-70);
  --background-brand-purple-extra-light: var(--brand-purple-5);
  --background-brand-purple-hover: var(--brand-purple-10);
  --background-brand-purple-light: var(--brand-purple-10);
  --background-brand-purple-primary: var(--brand-purple-50);
  --background-brand-purple-strong: var(--brand-purple-70);
  --background-brand-teal-extra-light: var(--brand-teal-5);
  --background-brand-teal-light: var(--brand-teal-10);
  --background-brand-teal-primary: var(--brand-teal-50);
  --background-brand-teal-strong: var(--brand-teal-70);
  --background-error-light: var(--sentiment-error-10);
  --background-error-primary: var(--sentiment-error-50);
  --background-error-strong: var(--sentiment-error-70);
  --background-info-light: var(--sentiment-information-10);
  --background-info-primary: var(--sentiment-information-50);
  --background-info-strong: var(--sentiment-information-70);
  --background-neutral-black-fixed: var(--neutral-base-black);
  --background-neutral-disabled: var(--neutral-gray-20);
  --background-neutral-octonary: var(--neutral-gray-80);
  --background-neutral-primary: var(--neutral-base-white);
  --background-neutral-primary-inverse: var(--neutral-base-black);
  --background-neutral-quaternary: var(--neutral-gray-20);
  --background-neutral-quinary: var(--neutral-gray-30);
  --background-neutral-secondary: var(--neutral-gray-5);
  --background-neutral-senary: var(--neutral-gray-50);
  --background-neutral-septenary: var(--neutral-gray-70);
  --background-neutral-tertiary: var(--neutral-gray-10);
  --background-neutral-white-fixed: var(--neutral-base-white);
  --background-success-light: var(--sentiment-success-10);
  --background-success-primary: var(--sentiment-success-50);
  --background-success-strong: var(--sentiment-success-70);
  --background-warning-light: var(--sentiment-warning-10);
  --background-warning-primary: var(--sentiment-warning-50);
  --background-warning-strong: var(--sentiment-warning-70);
  --borders-brand-aqua-light: var(--brand-aqua-10);
  --borders-brand-aqua-primary: var(--brand-aqua-50);
  --borders-brand-aqua-strong: var(--brand-aqua-70);
  --borders-brand-purple-light: var(--brand-purple-10);
  --borders-brand-purple-primary: var(--brand-purple-50);
  --borders-brand-purple-strong: var(--brand-purple-70);
  --borders-brand-teal-light: var(--brand-teal-10);
  --borders-brand-teal-primary: var(--brand-teal-50);
  --borders-brand-teal-strong: var(--brand-teal-70);
  --borders-error-light: var(--sentiment-error-10);
  --borders-error-primary: var(--sentiment-error-50);
  --borders-error-strong: var(--sentiment-error-70);
  --borders-info-light: var(--sentiment-information-10);
  --borders-info-primary: var(--sentiment-information-50);
  --borders-info-strong: var(--sentiment-information-70);
  --borders-neutral-disabled: var(--neutral-gray-20);
  --borders-neutral-light: var(--neutral-gray-10);
  --borders-neutral-primary: var(--neutral-gray-20);
  --borders-neutral-solid: var(--neutral-base-black);
  --borders-neutral-strong: var(--neutral-gray-40);
  --borders-success-light: var(--sentiment-success-10);
  --borders-success-primary: var(--sentiment-success-50);
  --borders-success-strong: var(--sentiment-success-70);
  --borders-warning-light: var(--sentiment-warning-10);
  --borders-warning-primary: var(--sentiment-warning-50);
  --borders-warning-strong: var(--sentiment-warning-70);
  --text-brand-aqua-primary: var(--brand-aqua-50);
  --text-brand-aqua-primary-fixed: var(--brand-aqua-50);
  --text-brand-aqua-secondary: var(--brand-aqua-70);
  --text-brand-purple-primary: var(--brand-purple-50);
  --text-brand-purple-primary-fixed: var(--brand-purple-50);
  --text-brand-purple-secondary: var(--brand-purple-70);
  --text-brand-teal-primary: var(--brand-teal-50);
  --text-brand-teal-primary-fixed: var(--brand-teal-50);
  --text-brand-teal-secondary: var(--brand-teal-70);
  --text-error-primary: var(--sentiment-error-50);
  --text-error-primary-fixed: var(--sentiment-error-50);
  --text-error-secondary: var(--sentiment-error-60);
  --text-info-primary: var(--sentiment-information-50);
  --text-info-primary-fixed: var(--sentiment-information-50);
  --text-info-secondary: var(--sentiment-information-70);
  --text-neutral-black-fixed: var(--neutral-base-black);
  --text-neutral-disabled: var(--neutral-gray-20);
  --text-neutral-disabled-inverse: var(--neutral-base-white);
  --text-neutral-inverse: var(--neutral-base-white);
  --text-neutral-placeholder: var(--neutral-gray-40);
  --text-neutral-primary: var(--neutral-base-black);
  --text-neutral-quaternary: var(--neutral-gray-70);
  --text-neutral-secondary: var(--neutral-gray-90);
  --text-neutral-tertiary: var(--neutral-gray-80);
  --text-neutral-white-fixed: var(--neutral-base-white);
  --text-success-primary: var(--sentiment-success-50);
  --text-success-primary-fixed: var(--sentiment-success-50);
  --text-success-secondary: var(--sentiment-success-70);
  --text-warning-primary: var(--sentiment-warning-50);
  --text-warning-primary-fixed: var(--sentiment-warning-50);
  --text-warning-secondary: var(--sentiment-warning-70);
}

/* Dark Theme Semantic Colors */
[data-theme=Dark] {
  --background-brand-aqua-light: var(--brand-aqua-90);
  --background-brand-aqua-primary: var(--brand-aqua-50);
  --background-brand-aqua-strong: var(--brand-aqua-70);
  --background-brand-purple-extra-light: var(--brand-purple-90);
  --background-brand-purple-hover: var(--background-neutral-tertiary);
  --background-brand-purple-light: var(--brand-purple-90);
  --background-brand-purple-primary: var(--brand-purple-50);
  --background-brand-purple-strong: var(--brand-purple-70);
  --background-brand-teal-extra-light: var(--brand-teal-90);
  --background-brand-teal-light: var(--brand-teal-90);
  --background-brand-teal-primary: var(--brand-teal-50);
  --background-brand-teal-strong: var(--brand-teal-70);
  --background-error-light: var(--sentiment-error-90);
  --background-error-primary: var(--sentiment-error-50);
  --background-error-strong: var(--sentiment-error-70);
  --background-info-light: var(--sentiment-information-90);
  --background-info-primary: var(--sentiment-information-50);
  --background-info-strong: var(--sentiment-information-70);
  --background-neutral-black-fixed: var(--neutral-base-black);
  --background-neutral-disabled: var(--neutral-gray-80);
  --background-neutral-octonary: var(--neutral-gray-20);
  --background-neutral-primary: var(--neutral-base-black);
  --background-neutral-primary-inverse: var(--neutral-base-white);
  --background-neutral-quaternary: var(--neutral-gray-80);
  --background-neutral-quinary: var(--neutral-gray-70);
  --background-neutral-secondary: var(--neutral-gray-95);
  --background-neutral-senary: var(--neutral-gray-50);
  --background-neutral-septenary: var(--neutral-gray-30);
  --background-neutral-tertiary: var(--neutral-gray-90);
  --background-neutral-white-fixed: var(--neutral-base-white);
  --background-success-light: var(--sentiment-success-90);
  --background-success-primary: var(--sentiment-success-50);
  --background-success-strong: var(--sentiment-success-70);
  --background-warning-light: var(--sentiment-warning-90);
  --background-warning-primary: var(--sentiment-warning-50);
  --background-warning-strong: var(--sentiment-warning-70);
  --borders-brand-aqua-light: var(--borders-neutral-primary);
  --borders-brand-aqua-primary: var(--borders-neutral-solid);
  --borders-brand-aqua-strong: var(--borders-neutral-strong);
  --borders-brand-purple-light: var(--borders-neutral-primary);
  --borders-brand-purple-primary: var(--borders-neutral-solid);
  --borders-brand-purple-strong: var(--borders-neutral-strong);
  --borders-brand-teal-light: var(--brand-teal-90);
  --borders-brand-teal-primary: var(--brand-teal-50);
  --borders-brand-teal-strong: var(--brand-teal-70);
  --borders-error-light: var(--borders-neutral-primary);
  --borders-error-primary: var(--borders-neutral-solid);
  --borders-error-strong: var(--borders-neutral-strong);
  --borders-info-light: var(--borders-neutral-primary);
  --borders-info-primary: var(--borders-neutral-solid);
  --borders-info-strong: var(--borders-neutral-strong);
  --borders-neutral-disabled: var(--neutral-gray-80);
  --borders-neutral-light: var(--neutral-gray-90);
  --borders-neutral-primary: var(--neutral-gray-80);
  --borders-neutral-solid: var(--neutral-base-white);
  --borders-neutral-strong: var(--neutral-gray-50);
  --borders-success-light: var(--borders-neutral-primary);
  --borders-success-primary: var(--borders-neutral-solid);
  --borders-success-strong: var(--borders-neutral-strong);
  --borders-warning-light: var(--borders-neutral-primary);
  --borders-warning-primary: var(--borders-neutral-solid);
  --borders-warning-strong: var(--borders-neutral-strong);
  --text-brand-aqua-primary: var(--text-neutral-primary);
  --text-brand-aqua-primary-fixed: var(--brand-aqua-50);
  --text-brand-aqua-secondary: var(--text-neutral-tertiary);
  --text-brand-purple-primary: var(--text-neutral-primary);
  --text-brand-purple-primary-fixed: var(--brand-purple-50);
  --text-brand-purple-secondary: var(--text-neutral-tertiary);
  --text-brand-teal-primary: var(--text-neutral-primary);
  --text-brand-teal-primary-fixed: var(--brand-teal-50);
  --text-brand-teal-secondary: var(--text-neutral-tertiary);
  --text-error-primary: var(--text-neutral-primary);
  --text-error-primary-fixed: var(--sentiment-error-50);
  --text-error-secondary: var(--text-neutral-tertiary);
  --text-info-primary: var(--text-neutral-primary);
  --text-info-primary-fixed: var(--sentiment-information-50);
  --text-info-secondary: var(--text-neutral-tertiary);
  --text-neutral-black-fixed: var(--neutral-base-black);
  --text-neutral-disabled: var(--neutral-gray-80);
  --text-neutral-disabled-inverse: var(--neutral-base-black);
  --text-neutral-inverse: var(--neutral-base-black);
  --text-neutral-placeholder: var(--neutral-gray-60);
  --text-neutral-primary: var(--neutral-base-white);
  --text-neutral-quaternary: var(--neutral-gray-30);
  --text-neutral-secondary: var(--neutral-gray-10);
  --text-neutral-tertiary: var(--neutral-gray-20);
  --text-neutral-white-fixed: var(--neutral-base-white);
  --text-success-primary: var(--text-neutral-white-fixed);
  --text-success-primary-fixed: var(--sentiment-success-50);
  --text-success-secondary: var(--text-neutral-tertiary);
  --text-warning-primary: var(--text-neutral-primary);
  --text-warning-primary-fixed: var(--sentiment-warning-50);
  --text-warning-secondary: var(--text-neutral-tertiary);
}

/* This is a collection of Primitive Colors.
 Unlike Semantic colors (color.css) these variables will be equal to the same color value in all themes.
 Ideally, these colors should be used for components that are not theme dependent.
 In the future it's possible that we will only need to use these colors in Semantic colors (colors.css).
 */
/* Colors are taken from DISCO Variables New Figma File - Primitive colors variables collection
 via variables2css plugin that generates css code based on Figma variables values and names.
 We're using css here in order to support not only scss, but also css files.
 :root is used here instead of "[data-theme="Mode 1"]" to define css variables
 that can be used in the entire app. 
 Also, stylelint fix might be required for autogenerated colors, which can be done in one command.
 */
/* Primitive Colors */
:root {
  --accent-orange-10: #fff6e5;
  --accent-orange-100: #5c3b00;
  --accent-orange-20: #ffe5b7;
  --accent-orange-30: #ffd58a;
  --accent-orange-40: #ffc55c;
  --accent-orange-50: #ffb42e;
  --accent-orange-60: #ffa400;
  --accent-orange-70: #d68a00;
  --accent-orange-80: #ad7000;
  --accent-orange-90: #855500;
  --accent-strawberry-10: #ffe3e3;
  --accent-strawberry-100: #430d0d;
  --accent-strawberry-20: #ffcdcd;
  --accent-strawberry-30: #ffabab;
  --accent-strawberry-40: #f88585;
  --accent-strawberry-50: #ed6060;
  --accent-strawberry-60: #cb4a4a;
  --accent-strawberry-70: #a93737;
  --accent-strawberry-80: #872626;
  --accent-strawberry-90: #651818;
  --brand-aqua-10: #ebfffe;
  --brand-aqua-100: #005552;
  --brand-aqua-20: #bffffc;
  --brand-aqua-30: #94fffb;
  --brand-aqua-40: #68fff9;
  --brand-aqua-50: #3cfff7;
  --brand-aqua-60: #29ddd6;
  --brand-aqua-70: #19bbb5;
  --brand-aqua-80: #0d9994;
  --brand-aqua-90: #047773;
  --brand-purple-10: #e2d4ee;
  --brand-purple-100: #2f1c3e;
  --brand-purple-20: #decaee;
  --brand-purple-30: #d0b6e5;
  --brand-purple-40: #b592d2;
  --brand-purple-5: #f6edfd;
  --brand-purple-50: #8c52ba;
  --brand-purple-60: #7f4aa9;
  --brand-purple-70: #6c468a;
  --brand-purple-80: #5c3778;
  --brand-purple-90: #46295c;
  --brand-teal-10: #bfe4e8;
  --brand-teal-100: #00383f;
  --brand-teal-20: #aed8dc;
  --brand-teal-30: #85cad1;
  --brand-teal-40: #50b2bd;
  --brand-teal-5: #e0f8f9;
  --brand-teal-50: #0093a4;
  --brand-teal-60: #008493;
  --brand-teal-70: #007785;
  --brand-teal-80: #00636e;
  --brand-teal-90: #004b54;
  --neutral-base-black: #292f36;
  --neutral-base-white: #ffffff;
  --neutral-black-alpha-10: #292f361a;
  --neutral-black-alpha-20: #292f3633;
  --neutral-black-alpha-30: #292f364d;
  --neutral-black-alpha-40: #292f3666;
  --neutral-black-alpha-5: #292f360d;
  --neutral-black-alpha-50: #292f3680;
  --neutral-black-alpha-60: #292f3699;
  --neutral-black-alpha-70: #292f36b2;
  --neutral-black-alpha-80: #292f36cc;
  --neutral-black-alpha-90: #292f36e5;
  --neutral-black-alpha-95: #292f36f2;
  --neutral-gray-10: #e4e6e9;
  --neutral-gray-20: #d1d4d8;
  --neutral-gray-30: #bec2c7;
  --neutral-gray-40: #abb0b6;
  --neutral-gray-5: #f7f8fa;
  --neutral-gray-50: #989ea5;
  --neutral-gray-60: #858c94;
  --neutral-gray-70: #727a83;
  --neutral-gray-80: #5f6872;
  --neutral-gray-90: #4c5661;
  --neutral-gray-95: #394450;
  --neutral-white-alpha-10: #ffffff1a;
  --neutral-white-alpha-20: #ffffff33;
  --neutral-white-alpha-30: #ffffff4d;
  --neutral-white-alpha-40: #ffffff66;
  --neutral-white-alpha-5: #ffffff0d;
  --neutral-white-alpha-50: #ffffff80;
  --neutral-white-alpha-60: #ffffff99;
  --neutral-white-alpha-70: #ffffffb2;
  --neutral-white-alpha-80: #ffffffcc;
  --neutral-white-alpha-90: #ffffffe5;
  --neutral-white-alpha-95: #fffffff2;
  --sentiment-error-10: #ffe1dd;
  --sentiment-error-100: #480e07;
  --sentiment-error-20: #ffbfb6;
  --sentiment-error-30: #ff8677;
  --sentiment-error-40: #f95d4a;
  --sentiment-error-50: #e02d16;
  --sentiment-error-60: #c12814;
  --sentiment-error-70: #aa2513;
  --sentiment-error-80: #842418;
  --sentiment-error-90: #6a1b11;
  --sentiment-information-10: #dceffb;
  --sentiment-information-100: #0b2946;
  --sentiment-information-20: #bde0fa;
  --sentiment-information-30: #83c7f6;
  --sentiment-information-40: #40aaf0;
  --sentiment-information-50: #1892e3;
  --sentiment-information-60: #0b71be;
  --sentiment-information-70: #0a5a9a;
  --sentiment-information-80: #0d4d7f;
  --sentiment-information-90: #10416a;
  --sentiment-success-10: #e2f6e2;
  --sentiment-success-100: #0e360f;
  --sentiment-success-20: #c7ecc6;
  --sentiment-success-30: #9adc99;
  --sentiment-success-40: #66c365;
  --sentiment-success-50: #3ea33e;
  --sentiment-success-60: #308930;
  --sentiment-success-70: #286d29;
  --sentiment-success-80: #245724;
  --sentiment-success-90: #1f4820;
  --sentiment-warning-10: #fefce8;
  --sentiment-warning-100: #5e330f;
  --sentiment-warning-20: #fef8c3;
  --sentiment-warning-30: #fded8b;
  --sentiment-warning-40: #fcdc48;
  --sentiment-warning-50: #f9cb28;
  --sentiment-warning-60: #e9ae09;
  --sentiment-warning-70: #c88504;
  --sentiment-warning-80: #a05f08;
  --sentiment-warning-90: #7d4b07;
}

/*
   Font Awesome S3 Bucket URLs
   Current version: 6.6.0
   If you are changing the location of these files,
   see the readme in this directory for more detail on manual steps to take when uploading new files.
 */
/* This file is being copied and adopted to shared/css/typography.scss
   Updating styles in this file will require a manual sync of the that file.
*/
@font-face {
  font-family: "Barlow Semi Condensed Semibold";
  font-style: normal;
  font-weight: 600;
  src: url("/fonts/barlowSemiCondensed/BarlowSemiCondensed-SemiBold.ttf") format("truetype"), local("?");
}
@font-face {
  font-family: "Barlow Semi Condensed Medium";
  font-style: normal;
  font-weight: 500;
  src: url("/fonts/barlowSemiCondensed/BarlowSemiCondensed-Medium.ttf") format("truetype"), local("?");
}
html {
  font-size: 100%;
}

/* \u2014 example: all h3s in a ul need to look like h5s
    ul.icon-list {
      h3 { @include heading-sm }
    }
*/
.tooltip-module__heading-xxl___Wxave {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: var(--font-barlow-semi-condensed-semi-bold), "Barlow Semi Condensed Semibold", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-size: 3rem;
  line-height: 1.16;
}

.tooltip-module__heading-xl___9SIFv {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: var(--font-barlow-semi-condensed-semi-bold), "Barlow Semi Condensed Semibold", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-size: 2.125rem;
  line-height: 1.24;
}

.tooltip-module__heading-lg___pBoyG {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: var(--font-barlow-semi-condensed-semi-bold), "Barlow Semi Condensed Semibold", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-size: 1.75rem;
  line-height: 1.28;
}

.tooltip-module__heading-md___zYoPi {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: var(--font-barlow-semi-condensed-medium), "Barlow Semi Condensed Medium", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-size: 1.5rem;
  line-height: 1.32;
}

.tooltip-module__heading-sm___h6LQC {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 1.25rem;
  line-height: 1.4;
}

.tooltip-module__heading-xs___zF1vt {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 1rem;
  line-height: 1.48;
}

.tooltip-module__body-one___kliHg {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 1.25rem;
  line-height: 1.4;
}

.tooltip-module__body-two___zmg0f {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 1rem;
  line-height: 1.48;
}

.tooltip-module__body-three___Huwkw {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.875rem;
  line-height: 1.54;
}

.tooltip-module__body-four___YJRVJ {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.813rem;
  line-height: 1.64;
}

.tooltip-module__overline-one___ykjq0 {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0.04rem;
  font-size: 0.875rem;
  line-height: 1.6;
}

.tooltip-module__overline-two___QcjzG {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0.04rem;
  font-size: 0.813rem;
  line-height: 1.64;
}

.tooltip-module__overline-three___fba7M {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0.04rem;
  font-size: 0.688rem;
  line-height: 1.76;
}

strong,
.tooltip-module__strong___531QW {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
}

.tooltip-module__extra-strong___z3qHU {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 700;
  font-style: normal;
}

em,
.tooltip-module__em___9DUCL {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-style: italic;
}

strong em,
em strong,
.tooltip-module__em___9DUCL .tooltip-module__strong___531QW,
.tooltip-module__strong___531QW .tooltip-module__em___9DUCL {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-style: italic;
}

.tooltip-module__em___9DUCL .tooltip-module__extra-strong___z3qHU,
.tooltip-module__extra-strong___z3qHU .tooltip-module__em___9DUCL,
em .tooltip-module__extra-strong___z3qHU,
.tooltip-module__extra-strong___z3qHU em {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-style: italic;
}

figcaption,
.tooltip-module__figcaption___4dBW5 {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 0.813rem;
  margin: 0.5em 0 1em;
  line-height: 1.64;
}

.tooltip-module__tooltipOverlay___I-rkD {
  position: relative;
  width: fit-content;
}

.tooltip-module__tooltip___3zeep {
  visibility: hidden;
  position: absolute;
  z-index: 10;
  display: flex;
  align-items: center;
  height: fit-content;
  background-color: var(--background-neutral-primary-inverse);
  box-sizing: border-box;
  min-width: 64px;
  max-width: 256px;
  text-align: center;
  border-radius: 0.25rem;
  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.12), 0 0 12px 0 rgba(0, 0, 0, 0.12);
}
.tooltip-module__tooltip___3zeep .tooltip-module__tooltipText___-H-vF,
.tooltip-module__tooltip___3zeep i {
  color: var(--text-neutral-inverse);
  width: max-content;
}

.tooltip-module__tooltip-onTop___WQLw1 {
  display: flex;
}
.tooltip-module__tooltip-onTop___WQLw1::after {
  content: "";
  position: absolute;
  inset-block-start: 100%;
  inset-inline-start: 50%;
  border-style: solid;
  border-color: var(--background-neutral-primary-inverse) transparent transparent transparent;
}

.tooltip-module__tooltip-onRight___CBYB-::after {
  content: "";
  position: absolute;
  inset-inline-end: 100%;
  border-style: solid;
  border-color: transparent var(--background-neutral-primary-inverse) transparent transparent;
}
html[dir=rtl] .tooltip-module__tooltip-onRight___CBYB-::after {
  border-color: transparent transparent transparent var(--background-neutral-primary-inverse);
}

.tooltip-module__tooltip-onBottom___zqQPq::after {
  content: "";
  position: absolute;
  inset-block-end: 100%;
  inset-inline-start: 50%;
  border-style: solid;
  border-color: transparent transparent var(--background-neutral-primary-inverse) transparent;
}

.tooltip-module__tooltip-onLeft___dXcgj::after {
  content: "";
  position: absolute;
  inset-inline-start: 100%;
  border-style: solid;
  border-color: transparent transparent transparent var(--background-neutral-primary-inverse);
}
html[dir=rtl] .tooltip-module__tooltip-onLeft___dXcgj::after {
  border-color: transparent var(--background-neutral-primary-inverse) transparent transparent;
}

.tooltip-module__tooltip-l___YiC-j {
  padding: 0.5rem 1rem;
  gap: 0.375rem;
}
.tooltip-module__tooltip-l___YiC-j span {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 1.25rem;
  line-height: 1.4;
  margin-top: 2px;
  margin-bottom: 0;
}
.tooltip-module__tooltip-l___YiC-j i {
  font-size: 1rem;
  line-height: 125%;
  width: 1.25rem;
}
.tooltip-module__tooltip-l___YiC-j::after {
  border-width: 12px;
  margin-inline-start: -12px;
}
.tooltip-module__tooltip-l___YiC-j.tooltip-module__tooltip-onTop___WQLw1::after {
  border-bottom-width: 0;
}
.tooltip-module__tooltip-l___YiC-j.tooltip-module__tooltip-onRight___CBYB-::after {
  border-inline-start-width: 0;
}
.tooltip-module__tooltip-l___YiC-j.tooltip-module__tooltip-onBottom___zqQPq::after {
  border-top-width: 0;
}
.tooltip-module__tooltip-l___YiC-j.tooltip-module__tooltip-onLeft___dXcgj::after {
  border-inline-end-width: 0;
  margin-inline-start: 0;
  margin-inline-end: -12px;
}

.tooltip-module__tooltip-m___Yi8VT {
  padding: 0.375rem 0.75rem;
  gap: 0.25rem;
}
.tooltip-module__tooltip-m___Yi8VT span {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 1rem;
  line-height: 1.48;
  margin-top: 2px;
  margin-bottom: 0;
}
.tooltip-module__tooltip-m___Yi8VT i {
  font-size: 0.875rem;
  line-height: 125%;
  width: 1.125rem;
}
.tooltip-module__tooltip-m___Yi8VT::after {
  border-width: 9px;
  margin-inline-start: -9px;
}
.tooltip-module__tooltip-m___Yi8VT.tooltip-module__tooltip-onTop___WQLw1::after {
  border-bottom-width: 0;
}
.tooltip-module__tooltip-m___Yi8VT.tooltip-module__tooltip-onRight___CBYB-::after {
  border-inline-start-width: 0;
}
.tooltip-module__tooltip-m___Yi8VT.tooltip-module__tooltip-onBottom___zqQPq::after {
  border-top-width: 0;
}
.tooltip-module__tooltip-m___Yi8VT.tooltip-module__tooltip-onLeft___dXcgj::after {
  border-inline-end-width: 0;
  margin-inline-start: 0;
  margin-inline-end: -9px;
}

.tooltip-module__tooltip-s___18FfP {
  padding: 0.25rem 0.75rem;
  gap: 0.25rem;
}
.tooltip-module__tooltip-s___18FfP span {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.875rem;
  line-height: 1.54;
  margin-top: 2px;
  margin-bottom: 0;
}
.tooltip-module__tooltip-s___18FfP i {
  font-size: 0.8125rem;
  line-height: 125%;
  width: 1rem;
}
.tooltip-module__tooltip-s___18FfP::after {
  border-width: 6px;
  margin-inline-start: -6px;
}
.tooltip-module__tooltip-s___18FfP.tooltip-module__tooltip-onTop___WQLw1::after {
  border-bottom-width: 0;
}
.tooltip-module__tooltip-s___18FfP.tooltip-module__tooltip-onRight___CBYB-::after {
  border-inline-start-width: 0;
}
.tooltip-module__tooltip-s___18FfP.tooltip-module__tooltip-onBottom___zqQPq::after {
  border-top-width: 0;
}
.tooltip-module__tooltip-s___18FfP.tooltip-module__tooltip-onLeft___dXcgj::after {
  border-inline-end-width: 0;
  margin-inline-start: 0;
  margin-inline-end: -6px;
}

.tooltip-module__tooltip-xs___v4Wsu {
  padding: 0.125rem 0.75rem;
  gap: 0.25rem;
}
.tooltip-module__tooltip-xs___v4Wsu span {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.813rem;
  line-height: 1.64;
  margin-top: 2px;
  margin-bottom: 0;
}
.tooltip-module__tooltip-xs___v4Wsu i {
  font-size: 0.625rem;
  line-height: 125%;
  width: 0.8125rem;
}
.tooltip-module__tooltip-xs___v4Wsu::after {
  border-width: 6px;
  margin-inline-start: -6px;
}
.tooltip-module__tooltip-xs___v4Wsu.tooltip-module__tooltip-onTop___WQLw1::after {
  border-bottom-width: 0;
}
.tooltip-module__tooltip-xs___v4Wsu.tooltip-module__tooltip-onRight___CBYB-::after {
  border-inline-start-width: 0;
}
.tooltip-module__tooltip-xs___v4Wsu.tooltip-module__tooltip-onBottom___zqQPq::after {
  border-top-width: 0;
}
.tooltip-module__tooltip-xs___v4Wsu.tooltip-module__tooltip-onLeft___dXcgj::after {
  border-inline-end-width: 0;
  margin-inline-start: 0;
  margin-inline-end: -6px;
}`;
document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(css));
var tooltip_module_default = {
  "heading-xxl": "tooltip-module__heading-xxl___Wxave",
  "heading-xl": "tooltip-module__heading-xl___9SIFv",
  "heading-lg": "tooltip-module__heading-lg___pBoyG",
  "heading-md": "tooltip-module__heading-md___zYoPi",
  "heading-sm": "tooltip-module__heading-sm___h6LQC",
  "heading-xs": "tooltip-module__heading-xs___zF1vt",
  "body-one": "tooltip-module__body-one___kliHg",
  "body-two": "tooltip-module__body-two___zmg0f",
  "body-three": "tooltip-module__body-three___Huwkw",
  "body-four": "tooltip-module__body-four___YJRVJ",
  "overline-one": "tooltip-module__overline-one___ykjq0",
  "overline-two": "tooltip-module__overline-two___QcjzG",
  "overline-three": "tooltip-module__overline-three___fba7M",
  "strong": "tooltip-module__strong___531QW",
  "extra-strong": "tooltip-module__extra-strong___z3qHU",
  "em": "tooltip-module__em___9DUCL",
  "figcaption": "tooltip-module__figcaption___4dBW5",
  "tooltipOverlay": "tooltip-module__tooltipOverlay___I-rkD",
  "tooltip": "tooltip-module__tooltip___3zeep",
  "tooltipText": "tooltip-module__tooltipText___-H-vF",
  "tooltip-onTop": "tooltip-module__tooltip-onTop___WQLw1",
  "tooltip-onRight": "tooltip-module__tooltip-onRight___CBYB-",
  "tooltip-onBottom": "tooltip-module__tooltip-onBottom___zqQPq",
  "tooltip-onLeft": "tooltip-module__tooltip-onLeft___dXcgj",
  "tooltip-l": "tooltip-module__tooltip-l___YiC-j",
  "tooltip-m": "tooltip-module__tooltip-m___Yi8VT",
  "tooltip-s": "tooltip-module__tooltip-s___18FfP",
  "tooltip-xs": "tooltip-module__tooltip-xs___v4Wsu"
};

// src/tooltip/_Tooltip.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var TooltipOverlay = ({
  children,
  className
}) => /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("div", { className: (0, import_classnames2.default)(tooltip_module_default.tooltipOverlay, className), children });
var Tooltip = (0, import_react.forwardRef)(
  ({
    text,
    tooltipId,
    iconLeft,
    iconRight,
    direction = "onTop",
    className,
    size = "m",
    style = {}
  }, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(
      "div",
      {
        ref,
        id: tooltipId,
        className: (0, import_classnames2.default)(
          tooltip_module_default.tooltip,
          tooltip_module_default[`tooltip-${direction}`],
          tooltip_module_default[`tooltip-${size}`],
          className
        ),
        style,
        role: "tooltip",
        children: [
          iconLeft && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { ...iconLeft }),
          /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("span", { className: tooltip_module_default.tooltipText, children: text }),
          iconRight && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { ...iconRight })
        ]
      }
    );
  }
);
var Tooltip_default = Tooltip;

// src/tooltip/WithTooltip.tsx
var import_react2 = require("react");
var import_react_dom = require("react-dom");

// src/common/helpers/index.ts
var calculatePositionedElementStyles = ({
  nodePosition,
  positionedElementRef,
  direction,
  tailOffset: tailOffset2,
  tailLength,
  isPositionFixed = false
}) => {
  const styles = {};
  if (nodePosition && positionedElementRef.current && direction !== "none") {
    const rect = nodePosition.getBoundingClientRect();
    const tooltipRect = positionedElementRef.current.getBoundingClientRect();
    const scrollY = isPositionFixed ? 0 : window.scrollY;
    const scrollX = isPositionFixed ? 0 : window.scrollX;
    const textDirection = document.documentElement.dir || "ltr";
    const isLtr = textDirection === "ltr";
    const verticalMiddlePosition = rect.top + scrollY + rect.height / 2 - tooltipRect.height / 2;
    const verticalTopPosition = rect.top + scrollY - tooltipRect.height - tailOffset2 - tailLength;
    const verticalBottomPosition = rect.top + rect.height + scrollY + tailOffset2 + tailLength;
    const horizontalMiddlePosition = rect.left + scrollX + rect.width / 2 - tooltipRect.width / 2;
    const horizontalLeftPosition = rect.left + scrollX - tooltipRect.width - tailOffset2 - tailLength;
    const horizontalRightPosition = rect.right + scrollX + tailOffset2 + tailLength;
    switch (direction) {
      case "onRight":
        styles.top = verticalMiddlePosition;
        styles.left = isLtr ? horizontalRightPosition : horizontalLeftPosition;
        break;
      case "onBottom":
        styles.top = verticalBottomPosition;
        styles.left = horizontalMiddlePosition;
        break;
      case "onLeft":
        styles.top = verticalMiddlePosition;
        styles.left = isLtr ? horizontalLeftPosition : horizontalRightPosition;
        break;
      case "onTop":
      default:
        styles.top = verticalTopPosition;
        styles.left = horizontalMiddlePosition;
        break;
    }
  }
  return styles;
};
var updatePositionedElementStyles = ({
  nodePosition,
  positionedElementRef,
  direction,
  setPositionedElementStyles,
  tailOffset: tailOffset2,
  tailLength,
  isPositionFixed = false
}) => {
  setPositionedElementStyles(
    calculatePositionedElementStyles({
      nodePosition,
      positionedElementRef,
      direction,
      tailOffset: tailOffset2,
      tailLength,
      isPositionFixed
    })
  );
};

// src/tooltip/WithTooltip.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var tailOffset = 4;
var tailLengths = {
  l: 12,
  m: 9,
  s: 6,
  xs: 6
};
var WithTooltip = ({
  children,
  tooltipOverlayClassName,
  tooltipProps
}) => {
  const [nodePosition, setNodePosition] = (0, import_react2.useState)(null);
  const [showTooltip, setShowTooltip] = (0, import_react2.useState)(false);
  const [tooltipStyles, setTooltipStyles] = (0, import_react2.useState)({});
  const tooltipRef = (0, import_react2.useRef)(null);
  const handleShowTooltip = (show, event) => {
    setShowTooltip(show);
    setNodePosition(show ? event.target : null);
  };
  const tailLength = tailLengths[tooltipProps.size || "m"];
  const updateTooltipStyles = (0, import_react2.useCallback)(
    () => updatePositionedElementStyles({
      nodePosition,
      positionedElementRef: tooltipRef,
      direction: tooltipProps.direction,
      setPositionedElementStyles: setTooltipStyles,
      tailOffset,
      tailLength
    }),
    [nodePosition, tailLength, tooltipProps.direction]
  );
  (0, import_react2.useEffect)(() => {
    const updateTooltipPositionIfShown = () => {
      if (showTooltip) {
        updateTooltipStyles();
      }
    };
    updateTooltipPositionIfShown();
    window.addEventListener("resize", updateTooltipPositionIfShown);
    return () => {
      window.removeEventListener("resize", updateTooltipPositionIfShown);
    };
  }, [
    showTooltip,
    nodePosition,
    tooltipProps.direction,
    tailLength,
    updateTooltipStyles
  ]);
  const tooltipStyleProps = {
    visibility: showTooltip ? "visible" : "hidden",
    ...tooltipStyles
  };
  const componentToWrap = (0, import_react2.isValidElement)(children) && (0, import_react2.cloneElement)(children, {
    "aria-describedby": tooltipProps.tooltipId,
    onFocus: (event) => {
      var _a, _b;
      handleShowTooltip(true, event);
      (_b = (_a = children.props).onFocus) == null ? void 0 : _b.call(_a, event);
    },
    onBlur: (event) => {
      var _a, _b;
      handleShowTooltip(false, event);
      (_b = (_a = children.props).onBlur) == null ? void 0 : _b.call(_a, event);
    },
    onMouseEnter: (event) => {
      var _a, _b;
      handleShowTooltip(true, event);
      (_b = (_a = children.props).onMouseEnter) == null ? void 0 : _b.call(_a, event);
    },
    onMouseLeave: (event) => {
      var _a, _b;
      handleShowTooltip(false, event);
      (_b = (_a = children.props).onMouseLeave) == null ? void 0 : _b.call(_a, event);
    }
  });
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(TooltipOverlay, { className: tooltipOverlayClassName, children: [
    componentToWrap,
    showTooltip && (0, import_react_dom.createPortal)(
      /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
        Tooltip_default,
        {
          ...tooltipProps,
          ref: tooltipRef,
          style: tooltipStyleProps
        }
      ),
      document.body
    )
  ] });
};
var WithTooltip_default = WithTooltip;

// src/tags/tags.module.scss
var css2 = `@charset "UTF-8";
/*
   Font Awesome S3 Bucket URLs
   Current version: 6.6.0
   If you are changing the location of these files,
   see the readme in this directory for more detail on manual steps to take when uploading new files.
 */
/* This is a collection of Primitive Colors.
 Unlike Semantic colors (color.css) these variables will be equal to the same color value in all themes.
 Ideally, these colors should be used for components that are not theme dependent.
 In the future it's possible that we will only need to use these colors in Semantic colors (colors.css).
 */
/* Colors are taken from DISCO Variables New Figma File - Primitive colors variables collection
 via variables2css plugin that generates css code based on Figma variables values and names.
 We're using css here in order to support not only scss, but also css files.
 :root is used here instead of "[data-theme="Mode 1"]" to define css variables
 that can be used in the entire app. 
 Also, stylelint fix might be required for autogenerated colors, which can be done in one command.
 */
/* Primitive Colors */
:root {
  --accent-orange-10: #fff6e5;
  --accent-orange-100: #5c3b00;
  --accent-orange-20: #ffe5b7;
  --accent-orange-30: #ffd58a;
  --accent-orange-40: #ffc55c;
  --accent-orange-50: #ffb42e;
  --accent-orange-60: #ffa400;
  --accent-orange-70: #d68a00;
  --accent-orange-80: #ad7000;
  --accent-orange-90: #855500;
  --accent-strawberry-10: #ffe3e3;
  --accent-strawberry-100: #430d0d;
  --accent-strawberry-20: #ffcdcd;
  --accent-strawberry-30: #ffabab;
  --accent-strawberry-40: #f88585;
  --accent-strawberry-50: #ed6060;
  --accent-strawberry-60: #cb4a4a;
  --accent-strawberry-70: #a93737;
  --accent-strawberry-80: #872626;
  --accent-strawberry-90: #651818;
  --brand-aqua-10: #ebfffe;
  --brand-aqua-100: #005552;
  --brand-aqua-20: #bffffc;
  --brand-aqua-30: #94fffb;
  --brand-aqua-40: #68fff9;
  --brand-aqua-50: #3cfff7;
  --brand-aqua-60: #29ddd6;
  --brand-aqua-70: #19bbb5;
  --brand-aqua-80: #0d9994;
  --brand-aqua-90: #047773;
  --brand-purple-10: #e2d4ee;
  --brand-purple-100: #2f1c3e;
  --brand-purple-20: #decaee;
  --brand-purple-30: #d0b6e5;
  --brand-purple-40: #b592d2;
  --brand-purple-5: #f6edfd;
  --brand-purple-50: #8c52ba;
  --brand-purple-60: #7f4aa9;
  --brand-purple-70: #6c468a;
  --brand-purple-80: #5c3778;
  --brand-purple-90: #46295c;
  --brand-teal-10: #bfe4e8;
  --brand-teal-100: #00383f;
  --brand-teal-20: #aed8dc;
  --brand-teal-30: #85cad1;
  --brand-teal-40: #50b2bd;
  --brand-teal-5: #e0f8f9;
  --brand-teal-50: #0093a4;
  --brand-teal-60: #008493;
  --brand-teal-70: #007785;
  --brand-teal-80: #00636e;
  --brand-teal-90: #004b54;
  --neutral-base-black: #292f36;
  --neutral-base-white: #ffffff;
  --neutral-black-alpha-10: #292f361a;
  --neutral-black-alpha-20: #292f3633;
  --neutral-black-alpha-30: #292f364d;
  --neutral-black-alpha-40: #292f3666;
  --neutral-black-alpha-5: #292f360d;
  --neutral-black-alpha-50: #292f3680;
  --neutral-black-alpha-60: #292f3699;
  --neutral-black-alpha-70: #292f36b2;
  --neutral-black-alpha-80: #292f36cc;
  --neutral-black-alpha-90: #292f36e5;
  --neutral-black-alpha-95: #292f36f2;
  --neutral-gray-10: #e4e6e9;
  --neutral-gray-20: #d1d4d8;
  --neutral-gray-30: #bec2c7;
  --neutral-gray-40: #abb0b6;
  --neutral-gray-5: #f7f8fa;
  --neutral-gray-50: #989ea5;
  --neutral-gray-60: #858c94;
  --neutral-gray-70: #727a83;
  --neutral-gray-80: #5f6872;
  --neutral-gray-90: #4c5661;
  --neutral-gray-95: #394450;
  --neutral-white-alpha-10: #ffffff1a;
  --neutral-white-alpha-20: #ffffff33;
  --neutral-white-alpha-30: #ffffff4d;
  --neutral-white-alpha-40: #ffffff66;
  --neutral-white-alpha-5: #ffffff0d;
  --neutral-white-alpha-50: #ffffff80;
  --neutral-white-alpha-60: #ffffff99;
  --neutral-white-alpha-70: #ffffffb2;
  --neutral-white-alpha-80: #ffffffcc;
  --neutral-white-alpha-90: #ffffffe5;
  --neutral-white-alpha-95: #fffffff2;
  --sentiment-error-10: #ffe1dd;
  --sentiment-error-100: #480e07;
  --sentiment-error-20: #ffbfb6;
  --sentiment-error-30: #ff8677;
  --sentiment-error-40: #f95d4a;
  --sentiment-error-50: #e02d16;
  --sentiment-error-60: #c12814;
  --sentiment-error-70: #aa2513;
  --sentiment-error-80: #842418;
  --sentiment-error-90: #6a1b11;
  --sentiment-information-10: #dceffb;
  --sentiment-information-100: #0b2946;
  --sentiment-information-20: #bde0fa;
  --sentiment-information-30: #83c7f6;
  --sentiment-information-40: #40aaf0;
  --sentiment-information-50: #1892e3;
  --sentiment-information-60: #0b71be;
  --sentiment-information-70: #0a5a9a;
  --sentiment-information-80: #0d4d7f;
  --sentiment-information-90: #10416a;
  --sentiment-success-10: #e2f6e2;
  --sentiment-success-100: #0e360f;
  --sentiment-success-20: #c7ecc6;
  --sentiment-success-30: #9adc99;
  --sentiment-success-40: #66c365;
  --sentiment-success-50: #3ea33e;
  --sentiment-success-60: #308930;
  --sentiment-success-70: #286d29;
  --sentiment-success-80: #245724;
  --sentiment-success-90: #1f4820;
  --sentiment-warning-10: #fefce8;
  --sentiment-warning-100: #5e330f;
  --sentiment-warning-20: #fef8c3;
  --sentiment-warning-30: #fded8b;
  --sentiment-warning-40: #fcdc48;
  --sentiment-warning-50: #f9cb28;
  --sentiment-warning-60: #e9ae09;
  --sentiment-warning-70: #c88504;
  --sentiment-warning-80: #a05f08;
  --sentiment-warning-90: #7d4b07;
}

/* This is a collection of Primitive Colors.
 Unlike Semantic colors (color.css) these variables will be equal to the same color value in all themes.
 Ideally, these colors should be used for components that are not theme dependent.
 In the future it's possible that we will only need to use these colors in Semantic colors (colors.css).
 */
/* Colors are taken from DISCO Variables New Figma File - Primitive colors variables collection
 via variables2css plugin that generates css code based on Figma variables values and names.
 We're using css here in order to support not only scss, but also css files.
 :root is used here instead of "[data-theme="Mode 1"]" to define css variables
 that can be used in the entire app. 
 Also, stylelint fix might be required for autogenerated colors, which can be done in one command.
 */
/* Primitive Colors */
:root {
  --accent-orange-10: #fff6e5;
  --accent-orange-100: #5c3b00;
  --accent-orange-20: #ffe5b7;
  --accent-orange-30: #ffd58a;
  --accent-orange-40: #ffc55c;
  --accent-orange-50: #ffb42e;
  --accent-orange-60: #ffa400;
  --accent-orange-70: #d68a00;
  --accent-orange-80: #ad7000;
  --accent-orange-90: #855500;
  --accent-strawberry-10: #ffe3e3;
  --accent-strawberry-100: #430d0d;
  --accent-strawberry-20: #ffcdcd;
  --accent-strawberry-30: #ffabab;
  --accent-strawberry-40: #f88585;
  --accent-strawberry-50: #ed6060;
  --accent-strawberry-60: #cb4a4a;
  --accent-strawberry-70: #a93737;
  --accent-strawberry-80: #872626;
  --accent-strawberry-90: #651818;
  --brand-aqua-10: #ebfffe;
  --brand-aqua-100: #005552;
  --brand-aqua-20: #bffffc;
  --brand-aqua-30: #94fffb;
  --brand-aqua-40: #68fff9;
  --brand-aqua-50: #3cfff7;
  --brand-aqua-60: #29ddd6;
  --brand-aqua-70: #19bbb5;
  --brand-aqua-80: #0d9994;
  --brand-aqua-90: #047773;
  --brand-purple-10: #e2d4ee;
  --brand-purple-100: #2f1c3e;
  --brand-purple-20: #decaee;
  --brand-purple-30: #d0b6e5;
  --brand-purple-40: #b592d2;
  --brand-purple-5: #f6edfd;
  --brand-purple-50: #8c52ba;
  --brand-purple-60: #7f4aa9;
  --brand-purple-70: #6c468a;
  --brand-purple-80: #5c3778;
  --brand-purple-90: #46295c;
  --brand-teal-10: #bfe4e8;
  --brand-teal-100: #00383f;
  --brand-teal-20: #aed8dc;
  --brand-teal-30: #85cad1;
  --brand-teal-40: #50b2bd;
  --brand-teal-5: #e0f8f9;
  --brand-teal-50: #0093a4;
  --brand-teal-60: #008493;
  --brand-teal-70: #007785;
  --brand-teal-80: #00636e;
  --brand-teal-90: #004b54;
  --neutral-base-black: #292f36;
  --neutral-base-white: #ffffff;
  --neutral-black-alpha-10: #292f361a;
  --neutral-black-alpha-20: #292f3633;
  --neutral-black-alpha-30: #292f364d;
  --neutral-black-alpha-40: #292f3666;
  --neutral-black-alpha-5: #292f360d;
  --neutral-black-alpha-50: #292f3680;
  --neutral-black-alpha-60: #292f3699;
  --neutral-black-alpha-70: #292f36b2;
  --neutral-black-alpha-80: #292f36cc;
  --neutral-black-alpha-90: #292f36e5;
  --neutral-black-alpha-95: #292f36f2;
  --neutral-gray-10: #e4e6e9;
  --neutral-gray-20: #d1d4d8;
  --neutral-gray-30: #bec2c7;
  --neutral-gray-40: #abb0b6;
  --neutral-gray-5: #f7f8fa;
  --neutral-gray-50: #989ea5;
  --neutral-gray-60: #858c94;
  --neutral-gray-70: #727a83;
  --neutral-gray-80: #5f6872;
  --neutral-gray-90: #4c5661;
  --neutral-gray-95: #394450;
  --neutral-white-alpha-10: #ffffff1a;
  --neutral-white-alpha-20: #ffffff33;
  --neutral-white-alpha-30: #ffffff4d;
  --neutral-white-alpha-40: #ffffff66;
  --neutral-white-alpha-5: #ffffff0d;
  --neutral-white-alpha-50: #ffffff80;
  --neutral-white-alpha-60: #ffffff99;
  --neutral-white-alpha-70: #ffffffb2;
  --neutral-white-alpha-80: #ffffffcc;
  --neutral-white-alpha-90: #ffffffe5;
  --neutral-white-alpha-95: #fffffff2;
  --sentiment-error-10: #ffe1dd;
  --sentiment-error-100: #480e07;
  --sentiment-error-20: #ffbfb6;
  --sentiment-error-30: #ff8677;
  --sentiment-error-40: #f95d4a;
  --sentiment-error-50: #e02d16;
  --sentiment-error-60: #c12814;
  --sentiment-error-70: #aa2513;
  --sentiment-error-80: #842418;
  --sentiment-error-90: #6a1b11;
  --sentiment-information-10: #dceffb;
  --sentiment-information-100: #0b2946;
  --sentiment-information-20: #bde0fa;
  --sentiment-information-30: #83c7f6;
  --sentiment-information-40: #40aaf0;
  --sentiment-information-50: #1892e3;
  --sentiment-information-60: #0b71be;
  --sentiment-information-70: #0a5a9a;
  --sentiment-information-80: #0d4d7f;
  --sentiment-information-90: #10416a;
  --sentiment-success-10: #e2f6e2;
  --sentiment-success-100: #0e360f;
  --sentiment-success-20: #c7ecc6;
  --sentiment-success-30: #9adc99;
  --sentiment-success-40: #66c365;
  --sentiment-success-50: #3ea33e;
  --sentiment-success-60: #308930;
  --sentiment-success-70: #286d29;
  --sentiment-success-80: #245724;
  --sentiment-success-90: #1f4820;
  --sentiment-warning-10: #fefce8;
  --sentiment-warning-100: #5e330f;
  --sentiment-warning-20: #fef8c3;
  --sentiment-warning-30: #fded8b;
  --sentiment-warning-40: #fcdc48;
  --sentiment-warning-50: #f9cb28;
  --sentiment-warning-60: #e9ae09;
  --sentiment-warning-70: #c88504;
  --sentiment-warning-80: #a05f08;
  --sentiment-warning-90: #7d4b07;
}

/*
   Font Awesome S3 Bucket URLs
   Current version: 6.6.0
   If you are changing the location of these files,
   see the readme in this directory for more detail on manual steps to take when uploading new files.
 */
/* This file is being copied and adopted to shared/css/typography.scss
   Updating styles in this file will require a manual sync of the that file.
*/
@font-face {
  font-family: "Barlow Semi Condensed Semibold";
  font-style: normal;
  font-weight: 600;
  src: url("/fonts/barlowSemiCondensed/BarlowSemiCondensed-SemiBold.ttf") format("truetype"), local("?");
}
@font-face {
  font-family: "Barlow Semi Condensed Medium";
  font-style: normal;
  font-weight: 500;
  src: url("/fonts/barlowSemiCondensed/BarlowSemiCondensed-Medium.ttf") format("truetype"), local("?");
}
html {
  font-size: 100%;
}

/* \u2014 example: all h3s in a ul need to look like h5s
    ul.icon-list {
      h3 { @include heading-sm }
    }
*/
.tags-module__heading-xxl___wqhpF {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: var(--font-barlow-semi-condensed-semi-bold), "Barlow Semi Condensed Semibold", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-size: 3rem;
  line-height: 1.16;
}

.tags-module__heading-xl___4aYfC {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: var(--font-barlow-semi-condensed-semi-bold), "Barlow Semi Condensed Semibold", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-size: 2.125rem;
  line-height: 1.24;
}

.tags-module__heading-lg___ZmwhK {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: var(--font-barlow-semi-condensed-semi-bold), "Barlow Semi Condensed Semibold", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-size: 1.75rem;
  line-height: 1.28;
}

.tags-module__heading-md___duAM0 {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: var(--font-barlow-semi-condensed-medium), "Barlow Semi Condensed Medium", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-size: 1.5rem;
  line-height: 1.32;
}

.tags-module__heading-sm___7EPqo {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 1.25rem;
  line-height: 1.4;
}

.tags-module__heading-xs___bm0lY {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 1rem;
  line-height: 1.48;
}

.tags-module__body-one___KFqKP {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 1.25rem;
  line-height: 1.4;
}

.tags-module__body-two___sdp-A {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 1rem;
  line-height: 1.48;
}

.tags-module__body-three___2JF2p {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.875rem;
  line-height: 1.54;
}

.tags-module__body-four___I9sJk {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.813rem;
  line-height: 1.64;
}

.tags-module__overline-one___pW5Mn {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0.04rem;
  font-size: 0.875rem;
  line-height: 1.6;
}

.tags-module__overline-two___G-1Kx {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0.04rem;
  font-size: 0.813rem;
  line-height: 1.64;
}

.tags-module__overline-three___rUICV {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0.04rem;
  font-size: 0.688rem;
  line-height: 1.76;
}

strong,
.tags-module__strong___0bGpH {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
}

.tags-module__extra-strong___dNRGd {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 700;
  font-style: normal;
}

em,
.tags-module__em___cb-Ts {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-style: italic;
}

strong em,
em strong,
.tags-module__em___cb-Ts .tags-module__strong___0bGpH,
.tags-module__strong___0bGpH .tags-module__em___cb-Ts {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-style: italic;
}

.tags-module__em___cb-Ts .tags-module__extra-strong___dNRGd,
.tags-module__extra-strong___dNRGd .tags-module__em___cb-Ts,
em .tags-module__extra-strong___dNRGd,
.tags-module__extra-strong___dNRGd em {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-style: italic;
}

figcaption,
.tags-module__figcaption___OAQbJ {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 0.813rem;
  margin: 0.5em 0 1em;
  line-height: 1.64;
}

.tags-module__tags___qLMsX {
  display: flex;
  column-gap: 0.5em;
}
.tags-module__tags___qLMsX .tags-module__tag___cgocf {
  display: flex;
  align-items: baseline;
  gap: 2px;
  color: var(--neutral-base-black);
  padding: 2px 12px;
  background-color: var(--brand-teal-5);
  border-radius: 6.25rem;
  max-width: 15em;
}
.tags-module__tags___qLMsX .tags-module__tag___cgocf span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tags-module__tags___qLMsX .tags-module__tag___cgocf i {
  display: flex;
  justify-content: center;
}
.tags-module__tags___qLMsX .tags-module__tag___cgocf:has(i:first-child) {
  padding-inline-start: 8px;
}
.tags-module__tags___qLMsX .tags-module__tag___cgocf:has(i:not(:first-child)) {
  padding-inline-end: 8px;
}

.tags-module__tags-l___Vbf1P .tags-module__tag___cgocf span {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0.04rem;
  font-size: 0.875rem;
  line-height: 1.6;
  line-height: 1.5;
  margin-bottom: 0;
  margin-top: 1.5px;
}
.tags-module__tags-l___Vbf1P .tags-module__tag___cgocf i {
  font-size: 0.875rem;
  line-height: 1.25;
  width: 1.25rem;
  height: 1.125rem;
}

.tags-module__tags-m___3Vr7N .tags-module__tag___cgocf span {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0.04rem;
  font-size: 0.813rem;
  line-height: 1.64;
  line-height: 1.54;
  margin-bottom: 0;
  margin-top: 2px;
}
.tags-module__tags-m___3Vr7N .tags-module__tag___cgocf i {
  font-size: 0.75rem;
  line-height: 1.25;
  width: 1.125rem;
  height: 0.9375rem;
}

.tags-module__tags-s___kdKcg .tags-module__tag___cgocf span {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0.04rem;
  font-size: 0.688rem;
  line-height: 1.76;
  line-height: 1.8;
  margin-bottom: 0;
  margin-top: 1px;
}
.tags-module__tags-s___kdKcg .tags-module__tag___cgocf i {
  font-size: 0.625rem;
  line-height: 1.25;
  width: 1rem;
  height: 0.8125rem;
}`;
document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(css2));
var tags_module_default = {
  "heading-xxl": "tags-module__heading-xxl___wqhpF",
  "heading-xl": "tags-module__heading-xl___4aYfC",
  "heading-lg": "tags-module__heading-lg___ZmwhK",
  "heading-md": "tags-module__heading-md___duAM0",
  "heading-sm": "tags-module__heading-sm___7EPqo",
  "heading-xs": "tags-module__heading-xs___bm0lY",
  "body-one": "tags-module__body-one___KFqKP",
  "body-two": "tags-module__body-two___sdp-A",
  "body-three": "tags-module__body-three___2JF2p",
  "body-four": "tags-module__body-four___I9sJk",
  "overline-one": "tags-module__overline-one___pW5Mn",
  "overline-two": "tags-module__overline-two___G-1Kx",
  "overline-three": "tags-module__overline-three___rUICV",
  "strong": "tags-module__strong___0bGpH",
  "extra-strong": "tags-module__extra-strong___dNRGd",
  "em": "tags-module__em___cb-Ts",
  "figcaption": "tags-module__figcaption___OAQbJ",
  "tags": "tags-module__tags___qLMsX",
  "tag": "tags-module__tag___cgocf",
  "tags-l": "tags-module__tags-l___Vbf1P",
  "tags-m": "tags-module__tags-m___3Vr7N",
  "tags-s": "tags-module__tags-s___kdKcg"
};

// src/tags/_Tag.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");
var TagIcon = (0, import_react3.memo)(({ iconName, iconStyle, title }) => /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(FontAwesomeV6Icon_default, { iconName, iconStyle, title }));
var Tag = ({
  label,
  tooltipContent,
  tooltipId,
  icon
}) => {
  return tooltipContent && tooltipId ? /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
    WithTooltip_default,
    {
      tooltipProps: {
        direction: "onTop",
        text: tooltipContent,
        tooltipId
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)(
        "div",
        {
          tabIndex: 0,
          "aria-describedby": tooltipId,
          className: tags_module_default.tag,
          children: [
            icon && icon.placement === "left" && /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(TagIcon, { ...icon }),
            /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("span", { children: label }),
            icon && icon.placement === "right" && /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(TagIcon, { ...icon })
          ]
        }
      )
    }
  ) : /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("div", { className: tags_module_default.tag, children: [
    icon && icon.placement === "left" && /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(TagIcon, { ...icon }),
    /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("span", { children: label }),
    icon && icon.placement === "right" && /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(TagIcon, { ...icon })
  ] });
};
var Tag_default = (0, import_react3.memo)(Tag);

// src/tags/Tags.tsx
var import_jsx_runtime5 = require("react/jsx-runtime");
var Tags = ({
  tagsList,
  size = "m",
  className
}) => /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
  "div",
  {
    className: (0, import_classnames3.default)(
      tags_module_default.tags,
      tags_module_default[`tags-${size}`],
      className
    ),
    "data-testid": "tags",
    children: tagsList.map(({ tooltipId, label, tooltipContent, ariaLabel, icon }) => /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
      Tag_default,
      {
        tooltipId,
        label,
        ariaLabel,
        icon,
        tooltipContent
      },
      tooltipId
    ))
  }
);
var Tags_default = Tags;
